<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row p-3">
          <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
            <label>{{ $t('common_words.farm') }}: *</label>
            <br />
            <el-select
              id="farm_seeding_catching"
              clearable
              v-bind:collapse-tags="true"
              filterable
              class="select-primary custom-width-select required-farm shadow-sm"
              size="large"
              v-model="model.farm_id"
              @change="handleChange()"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="(option, index) in farms"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="index + option.id"
              ></el-option>
            </el-select>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-3 mb-3">
            <label>{{ $t('common_words.date') }}:</label>
            <br />
            <el-date-picker
              class="shadow-sm date-form"
              v-model="model.date_save"
              type="date"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd"
              :placeholder="`${$t('common_words.select')}...`"
              @change="handleDateChange"
            >
            </el-date-picker>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
            <label>{{ $t('common_words.week') }}:</label>
            <br />
            <el-select
              align="center"
              disabled
              v-model="model.week_pruning"
              :placeholder="`${$t('common_words.week')}...`"
            ></el-select>
          </div>
          <div class="col-12 col-md-4 col-xl-2">
            <label class="label-primary" style="color: transparent">{{
              $t('common_words.filter')
            }}</label
            ><br />
            <l-button
              :disabled="!model.week_pruning"
              wide
              type="info"
              class="btn-filter"
              @click="validate"
            >
              {{ $t('common_words.generate') }}
            </l-button>
          </div>
        </div>
      </card>
      <div v-if="messageAlert" class="alert alert-warning" role="alert">
        {{ messageAlert }}
      </div>
      <card
        class="custom-shadow-card-header mt-4"
        v-if="showPruningCatch && !messageAlert"
      >
        <div class="mt-4 px-4">
          <div class="row" v-if="isIndex() && (isCreate() || isUpdate())">
            <div class="table-responsive">
              <table class="table table-striped table-bordered not-last-td">
                <thead>
                  <tr class="cusmtom-thead-color">
                    <th
                      scope="col"
                      class="text-center p-3 custom-header-label"
                      v-bind:style="{ minWidth: '100px' }"
                    >
                      <strong>{{ $t('common_words.allotment') }}</strong>
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      {{ $t('common_words.allotment_area_ha') }}
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      {{ $t('sowing.sowing_week') }}
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      {{ $t('common_words.variety') }}
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      {{ $t('pruning.Number_plants') }}
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      {{ $t('pruning.pruning_reasons') }}
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      {{ $t('pruning.pruning_methods') }}
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      {{ $t('pruning.pruning_area') }}
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      {{ $t('pruning.pruning_plant') }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(
                      rowData, indexRowData
                    ) in tableData.sowing_catch_details"
                    :key="indexRowData"
                  >
                    <td class="text-center">
                      {{ rowData.lot ? rowData.lot.name : '' }}
                    </td>
                    <td class="text-center">
                      {{ rowData.lot ? rowData.lot.area : '' }}
                    </td>
                    <td class="text-center">
                      {{ tableData.sowing_week ? tableData.sowing_week : '' }}
                    </td>
                    <td class="text-center">
                      {{
                        rowData.crop_variety.name
                          ? rowData.crop_variety.name
                          : ''
                      }}
                    </td>
                    <td class="text-center">
                      {{ rowData.plant_number }}
                    </td>
                    <td class="text-center">
                      <el-select
                        clearable
                        filterable
                        width="10"
                        class="select-primary custom-width-select required-method shadow-sm"
                        size="large"
                        v-model="model.pruning_method_id[indexRowData]"
                        :placeholder="`${$t('common_words.select2')}...`"
                      >
                        <el-option
                          v-for="(option, i) in pruningMethods"
                          class="select-primary"
                          :value="option.id"
                          :label="option.name"
                          :key="`${i}-${option.id}`"
                        ></el-option>
                      </el-select>
                    </td>
                    <td class="text-center">
                      <el-select
                        clearable
                        filterable
                        width="10"
                        class="select-primary custom-width-select required-reason shadow-sm"
                        size="large"
                        v-model="model.pruning_reason_id[indexRowData]"
                        :placeholder="`${$t('common_words.select2')}...`"
                      >
                        <el-option
                          v-for="(option, i) in pruningReasons"
                          class="select-primary"
                          :value="option.id"
                          :label="option.name"
                          :key="`${i}-${option.id}`"
                        ></el-option>
                      </el-select>
                    </td>
                    <td>
                      <el-input
                        type="number"
                        class="shadow-sm text-center"
                        v-model.number="model.pruning_area[indexRowData]"
                        name="pruning.pruning_area"
                        v-validate="modelValidations.pruning_area"
                        :error="getError('pruning.pruning_area', true)"
                        style="min-width: 140px"
                        min="0"
                        placeholder="..."
                      >
                        <template slot="append">(ha)</template></el-input
                      >
                    </td>
                    <td>
                      <el-input
                        type="number"
                        class="shadow-sm text-center"
                        v-model.number="model.number_plant[indexRowData]"
                        v-validate="modelValidations.number_plant"
                        name="pruning.pruning_plant"
                        :error="getError('pruning.pruning_plant', true)"
                        style="min-width: 140px"
                        min="0"
                        placeholder="..."
                      >
                        <template slot="append">(uds)</template></el-input
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-if="!messageAlert" class="row">
            <div class="col-6 pr-0 text-right" v-if="isCreate() || isUpdate()">
              <l-button
                wide
                type="info"
                class="btn-filter m-4"
                @click="validateDetail()"
              >
                {{ $t('common_words.save') }}
              </l-button>
            </div>
            <div class="col-6 pl-0 text-left" v-if="isDelete()">
              <l-button
                wide
                type="danger"
                class="btn-filter m-4"
                @click="confirmDelete()"
              >
                {{ $t('common_words.delete') }}
              </l-button>
            </div>
          </div>
        </div>
      </card>
      <br />
    </div>
  </div>
</template>

<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util.js';
import { MixinNotification } from 'src/mixins/mixin-notification.js';
import { resetObjectProperties } from 'src/util/Util.js';
import MixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinForm from 'src/mixins/forms/mixin-form';
import moment from 'moment';
import SweetAlert from 'src/class/Alerts';
import i18n from 'src/i18n';

export default {
  data() {
    return {
      model: {
        crop_variety_id: [],
        date_save: null,
        details_id: [],
        farm_id: null,
        lot_id: [],
        number_plant: [],
        pruning_area: [],
        pruning_method_id: [],
        pruning_reason_id: [],
        week_pruning: null,
      },
      modelValidations: {
        pruning_area: {
          required: true,
        },
        number_plant: {
          required: true,
        },
      },
      tableData: [],
      showPruningCatch: null,
      showTable: null,
      farms: [],
      lots: [],
      cropVariety: [],
      pruningReasons: [],
      pruningMethods: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      pickerOptionsDetails: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
      messageAlert: null,
    };
  },

  mixins: [MixinNotification, MixinMasters, MixinPermissions, MixinForm],

  methods: {
    handleChange() {
      this.showPruningCatch = false;
    },

    getLotId() {
      this.model.lot_id = [];
      this.tableData.sowing_catch_details.forEach((details) => {
        this.model.lot_id.push(details.lot.id);
      });
    },

    getVarietyId() {
      this.model.crop_variety_id = [];
      this.tableData.sowing_catch_details.forEach((details) => {
        this.model.crop_variety_id.push(details.crop_variety.id);
      });
    },

    allotmentAreaById(lotId) {
      const lot = this.lots.find((lot) => Number(lot.id) === Number(lotId));

      return lot ? lot.area : null;
    },

    handleDelete(index) {
      this.model.pruning_reason_id.splice(index, 1);
      this.model.pruning_method_id.splice(index, 1);
      this.model.pruning_area.splice(index, 1);
      this.model.number_plant.splice(index, 1);
    },

    handleDateChange(value) {
      if (isset(this.model.farm_id)) {
        this.calculateWeek(value, this.model.farm_id);
      }
      this.showPruningCatch = false;
    },

    calculateWeek(reception_date, farm_id) {
      if (isset(reception_date) && isset(farm_id)) {
        const formattedDate = moment(reception_date).format('YYYY-MM-DD');
        Axios.getMasters(
          `pruning/catching/calculateWeekFromDate/${formattedDate}/${farm_id}`
        )
          .then((response) => {
            if (response.data.data.isGregorianCalendar) {
              this.model.farmSelected = this.farms.find(
                (farm) => farm.id === farm_id
              );

              SweetAlert.warning(
                `${i18n.t('sweet_alert.common.the_farm')}"${
                  this.model.farmSelected.name
                }" ${i18n.t('sweet_alert.common.no_registered_calendar')}
                ${i18n.t('sweet_alert.common.unvalid_year_calendar_gregorian')}`
              );
            }
            this.model.week_pruning = Number(response.data.data.result);
          })
          .catch((error) => {
            this.showMessageErrors(error);
            this.model.week_pruning = null;
          });
      } else {
        this.model.week_pruning = null;
      }
    },

    confirmDelete() {
      if (this.model.id) {
        SweetAlert.delete('la captura de poda seleccionada').then((result) => {
          if (result.value) this.deletePruningCatch();
        });
      } else this.cleanForm();
    },

    cleanForm() {
      this.messageAlert = null;
      this.model = {
        ...resetObjectProperties(this.model, [
          'farm_id',
          'date_save',
          'week_pruning',
        ]),
      };
    },

    deletePruningCatch() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.model.route = 'pruning/catchs';
        Axios.destroyMaster(this.model)
          .then(() => {
            this.showSowingCatch = false;
            this.cleanForm();
            this.showHideLoading();
            this.showNotification(
              `Has eliminado la captura de poda correctamente`,
              'success',
              'nc-simple-remove',
              'Eliminación exitosa...'
            );
          })
          .catch((error) => {
            this.showHideLoading();
            this.showMessageErrors(error);
          });
      } else {
        this.showMessageAccess();
      }
    },

    validateDetail() {
      if (!isset(this.model.pruning_reason_id))
        return this.validationInputsRequired('reason');
      else if (!isset(this.model.pruning_method_id))
        return this.validationInputsRequired('method');
      else {
        this.getLotId();
        this.getVarietyId();
        this.storeUpdatePruningCatchs();
      }
    },

    validate() {
      if (this.model.farm_id == null)
        return this.validationInputsRequired('farm');
      else {
        this.messageAlert = null;
        this.cleanForm();
        this.loadData();
      }
    },

    storeUpdatePruningCatchs() {
      this.showHideLoading(true);

      if (this.isCreate() || this.isUpdate()) {
        this.model.route = 'pruning/catchs';

        if (this.model.id) {
          Axios.updateMaster(this.model)
            .then((response) => {
              this.showHideLoading();
              SweetAlert.success(response.data.message).then(() => {
                this.showPruningCatch = false;
                this.cleanForm();
              });
            })
            .catch((error) => {
              this.showHideLoading();
              this.showMessageErrors(error);
            });
        } else {
          Axios.saveMaster(this.model)
            .then((response) => {
              this.showHideLoading();
              SweetAlert.success(response.data.message).then(() => {
                this.showPruningCatch = false;
                this.cleanForm();
              });
            })
            .catch((error) => {
              this.showHideLoading();
              this.showMessageErrors(error);
            });
        }
      } else {
        this.showMessageAccess();
        this.showHideLoading();
      }
    },

    loadData() {
      this.showHideLoading(true);
      let data = {
        farm_id: this.model.farm_id,
        week_pruning: this.model.week_pruning,
        date: this.model.date_save,
        route: 'pruning/catching',
      };
      this.showPruningCatch = true;

      Promise.all([
        Axios.getMasters('farms/farms/lots/' + this.model.farm_id),
        Axios.postMasters(data),
        Axios.getMasters('cropvarieties'),
        Axios.getMasters('pruning/reasons/field'),
        Axios.getMasters('pruning/methods/field'),
      ])
        .then((response) => {
          const [
            responseLots,
            responsePruningCatch,
            responseCropVariety,
            responsePruningReason,
            responsePruningMethod,
          ] = response;
          this.lots = responseLots.data.data;
          const pruningCatch = responsePruningCatch.data.data;
          this.tableData = pruningCatch;
          this.cropVariety = responseCropVariety.data.data;
          this.pruningReasons = responsePruningReason.data.data;
          this.pruningMethods = responsePruningMethod.data.data;

          if (pruningCatch['closing']) {
            this.messageAlert = pruningCatch['closing'].message;
          } else this.messageAlert = null;

          if (pruningCatch.sowing_catch_details.length > 0) {
            if (pruningCatch.id) this.model.id = pruningCatch.id;
            const lotSelecteds = [];

            pruningCatch.sowing_catch_details.forEach((sowingDetail) => {
              const { lot_id, crop_variety_id } = sowingDetail;

              pruningCatch.pruning_catch_details.find((prunningDetail) => {
                const validate = `${prunningDetail.lot_id}-${prunningDetail.crop_variety_id}`;
                const toValidate = `${lot_id}-${crop_variety_id}`;

                if (validate === toValidate) {
                  const {
                    id,
                    number_plant,
                    pruning_area,
                    pruning_method_id,
                    pruning_reason_id,
                  } = prunningDetail;

                  lotSelecteds.push(lot_id);
                  this.model.details_id.push(id);
                  this.model.pruning_method_id.push(pruning_method_id);
                  this.model.pruning_reason_id.push(pruning_reason_id);
                  this.model.pruning_area.push(pruning_area);
                  this.model.number_plant.push(number_plant);
                } else {
                  lotSelecteds.push(null);
                  //this.model.pruning_method_id.push(null);
                  //this.model.pruning_reason_id.push(null);
                  //this.model.pruning_area.push(null);
                  //this.model.number_plant.push(null);
                }
              });
            });

            try {
              this.model.lot_id = [];
              setTimeout(() => {
                this.model.lot_id = [...lotSelecteds];
              }, 5);

              this.showPruningCatch = true;
            } catch (error) {}
          } else {
            this.showPruningCatch = true;
            this.cleanForm();
          }

          this.showHideLoading();
        })
        .catch((error) => {
          this.showMessageErrors(error);
        });
    },
  },
  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);
      Promise.all([Axios.getMasters('farms/farms/onlyfruit')])
        .then((response) => {
          const [responseFarm] = response;
          this.farms = responseFarm.data.data;

          this.showHideLoading();
        })
        .catch((error) => {
          this.showMessageErrors(error);
        });
    } else {
      this.showHideLoading();
    }
  },
};
</script>
